// Single source of truth for dispute reason display labels.
// Consumed by AdminDisputes, DisputeResolveModal, and DisputeForm.
export const REASON_LABELS: Record<string, string> = {
  no_show: "No-show / didn't arrive",
  poor_work: 'Poor work quality',
  safety: 'Safety concern',
  other: 'Other',
};

export const reasonLabel = (slug: string): string => REASON_LABELS[slug] || slug;
